// 🚀 Universal API Base: Always use env vars (HTTPS for Android too)

export function getAuthApiBase() {
  const base =
    process.env.REACT_APP_RUOTHSTORE_API || "http://localhost:8000";

  // console.log("📡 Auth API Base:", base);
  return base;
}


export function getAppApiBase() {
  const base =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5001";

  // console.log("📡 Recipe App API Base:", base);
  return base;
}